/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateRoleResourceForUserRequestUserAccountInner
 */
export interface UpdateRoleResourceForUserRequestUserAccountInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleResourceForUserRequestUserAccountInner
     */
    'role': UpdateRoleResourceForUserRequestUserAccountInnerRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleResourceForUserRequestUserAccountInner
     */
    'resourceId': string;
}

export const UpdateRoleResourceForUserRequestUserAccountInnerRoleEnum = {
    admin: 'USER_ACCOUNT_ADMIN',
    assist: 'USER_ACCOUNT_ASSIST'
} as const;

export type UpdateRoleResourceForUserRequestUserAccountInnerRoleEnum = typeof UpdateRoleResourceForUserRequestUserAccountInnerRoleEnum[keyof typeof UpdateRoleResourceForUserRequestUserAccountInnerRoleEnum];


